import {
    fetchAllCompanies,
    fetchAllUserInsurers,
    fetchAllUserSubagents,
    fetchRegisteredInsurers,
    fetchRegisteredSubagents,
    fetchInsurerHistory,
    fetchSubagentHistory,
    addSubagent,
    deactivateSubagent,
    fetchAllNormalUsers,
    fetchAllApiUsers,
    inviteUser,
    enableUser,
    reinviteUser,
    recallInvitation,
    deactivateUser,
    grantAdminRight,
    removeAdminRight,
    fetchInsurerCount,
    fetchSubagentCount,
    fetchNormalUserCount,
    fetchApiUserCount
} from '../Actions/userManagementAction';
import {CompanyId, Email, InviteUser} from '../../Config/dataModel';

export default (dispatch) => {
    return {
        fetchAllCompanies: () => {
            dispatch(fetchAllCompanies());
        },
        fetchAllUserInsurers: () => {
            dispatch(fetchAllUserInsurers());
        },
        fetchAllUserSubagents: () => {
            dispatch(fetchAllUserSubagents());
        },
        fetchRegisteredInsurers: () => {
            dispatch(fetchRegisteredInsurers());
        },
        fetchRegisteredSubagents: () => {
            dispatch(fetchRegisteredSubagents());
        },
        fetchInsurerHistory: () => {
            dispatch(fetchInsurerHistory());
        },
        fetchSubagentHistory: () => {
            dispatch(fetchSubagentHistory());
        },
        addSubagent: (data: CompanyId) => {
            dispatch(addSubagent(data));
        },
        deactivateSubagent: (data: CompanyId) => {
            dispatch(deactivateSubagent(data));
        },
        fetchAllNormalUsers: () => {
            dispatch(fetchAllNormalUsers());
        },
        fetchAllApiUsers: () => {
            dispatch(fetchAllApiUsers());
        },
        inviteUser: (data: InviteUser) => {
            dispatch(inviteUser(data));
        },
        enableUser: (data: Email) => {
            dispatch(enableUser(data));
        },
        reinviteUser: (data: Email) => {
            dispatch(reinviteUser(data));
        },
        recallInvitation: (data: Email) => {
            dispatch(recallInvitation(data));
        },
        deactivateUser: (data: Email) => {
            dispatch(deactivateUser(data));
        },
        grantAdminRight: (data: Email) => {
            dispatch(grantAdminRight(data));
        },
        removeAdminRight: (data: Email) => {
            dispatch(removeAdminRight(data));
        },
        fetchInsurerCount: () => {
            dispatch(fetchInsurerCount());
        },
        fetchSubagentCount: () => {
            dispatch(fetchSubagentCount());
        },
        fetchNormalUserCount: () => {
            dispatch(fetchNormalUserCount());
        },
        fetchApiUserCount: () => {
            dispatch(fetchApiUserCount());
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/userManagementDispatch.ts